module.exports = __webpack_public_path__ + "static/media/HighRadius-Trifecta-2020.c7a3a18e.svg";